module.exports = __webpack_public_path__ + "img/carret_right_user_primary.a155a00b.svg";